import {
  ASSET_LIST_PAGE_LOADED,
  ASSET_LIST_PAGE_UNLOADED,
  ASSET_DETAIL_PAGE_LOADED,
  ASSET_DETAIL_PAGE_UNLOADED,
  ASSET_CREATE,
  ASSET_IMPORT,
  ASSET_UPDATE,
  ASSET_ADD_PAGE_LOADED,
  ASSET_EDIT_PAGE_LOADED,
  ASSET_ADD_PAGE_UNLOADED,
  ASSET_EDIT_PAGE_UNLOADED,
  SITE_LIST_PAGE_LOADED,
  SITE_LIST_PAGE_UNLOADED,
  SITE_CREATE,
  LOAD_SITE,
  SITE_UPDATE,
  SITE_DETAIL_PAGE_LOADED,
  SITE_DETAIL_PAGE_UNLOADED,
  LOG_EVENT,
  EVENT_ADD_PAGE_LOADED,
  EVENT_ADD_PAGE_UNLOADED,
  EVENT_DETAIL_PAGE_LOADED,
  EVENT_DETAIL_PAGE_UNLOADED,
  EVENT_LIST_PAGE_LOADED,
  EVENT_LIST_PAGE_UNLOADED,
  CAMPAIGN_LIST_PAGE_LOADED,
  CAMPAIGN_LIST_PAGE_UNLOADED,
  CAMPAIGN_CREATE,
  CAMPAIGN_UPDATE,
  CAMPAIGN_ADD_PAGE_LOADED,
  CAMPAIGN_ADD_PAGE_UNLOADED,
  CAMPAIGN_EDIT_PAGE_LOADED,
  CAMPAIGN_DETAIL_PAGE_LOADED,
  CAMPAIGN_DETAIL_PAGE_UNLOADED,
  CAMPAIGN_ITEM_DETAIL_PAGE_LOADED,
  CAMPAIGN_ITEM_DETAIL_PAGE_UNLOADED,
  BULK_SEND_SMS_VIA_CAMPAIGN,
  SEND_SMS_VIA_CAMPAIGN_ITEM,
  ADD_CAMPAIGN_ITEM,
  REMOVE_CAMPAIGN_ITEM,
  CAMPAIGN_ITEMS_EDIT_PAGE_LOADED,
  CAMPAIGN_ITEMS_EDIT_PAGE_UNLOADED
} from "../constants/asset.action.types";

export default (state = {}, action) => {
  switch (action.type) {
    case ASSET_LIST_PAGE_LOADED:
      return {
        ...state,
        errors: action.error ? action.payload.error : null,
        assets: action.error ? null : action.payload.items
      };
    case ASSET_DETAIL_PAGE_LOADED:
      return {
        ...state,
        asset: action.error ? null : action.payload[0],
        events: action.error ? [] : action.payload[1].items
      };
    case ASSET_EDIT_PAGE_LOADED:
      return {
        ...state,
        sites: action.error ? null : action.payload[0],
        asset: action.error ? null : action.payload[1]
      };
    case ASSET_ADD_PAGE_LOADED:
      return {
        ...state,
        sites: action.error ? null : action.payload
      };
    case CAMPAIGN_ADD_PAGE_LOADED:
      return {
        ...state,
        sites: action.error ? null : action.payload[0],
        assets: action.error ? [] : action.payload[1].items
      };
    case SITE_DETAIL_PAGE_LOADED:
      return {
        ...state,
        site: action.error ? null : action.payload[0],
        events: action.error ? null : action.payload[1].items,
        events_total: action.error ? 0 : action.payload[1].total_count,
        assets: action.error ? null : action.payload[2].items,
        assets_total: action.error ? 0 : action.payload[2].total_count,
        campaigns: action.error ? null : action.payload[3]
      };
    case LOAD_SITE:
      return {
        ...state,
        site: action.error ? null : action.payload
      };
    case ASSET_CREATE:
    case ASSET_UPDATE:
    case SITE_CREATE:
    case SITE_UPDATE:
    case LOG_EVENT:
    case ASSET_IMPORT:
    case CAMPAIGN_CREATE:
    case CAMPAIGN_UPDATE:
    case BULK_SEND_SMS_VIA_CAMPAIGN:
    case SEND_SMS_VIA_CAMPAIGN_ITEM:
      return {
        ...state,
        errors: action.error ? action.payload.error : null
      };
    case SITE_LIST_PAGE_LOADED:
      return {
        ...state,
        errors: action.error ? action.payload.error : null,
        sites: action.error ? null : action.payload
      };
    case EVENT_ADD_PAGE_LOADED:
      return {
        ...state,
        sites: action.error ? null : action.payload[0],
        assets: action.error ? null : action.payload[1].items
      };
    case EVENT_DETAIL_PAGE_LOADED:
      return {
        ...state,
        event: action.error ? null : action.payload
      };
    case EVENT_LIST_PAGE_LOADED:
      return {
        ...state,
        events: action.error ? null : action.payload.items
      };
    case CAMPAIGN_LIST_PAGE_LOADED:
      return {
        ...state,
        campaigns: action.error ? null : action.payload
      };
    case CAMPAIGN_DETAIL_PAGE_LOADED:
      return {
        ...state,
        campaign: action.error ? null : action.payload
      };
    case CAMPAIGN_EDIT_PAGE_LOADED:
      return {
        ...state,
        sites: action.error ? null : action.payload[0],
        campaign: action.error ? null : action.payload[1]
      };
    case CAMPAIGN_ITEM_DETAIL_PAGE_LOADED:
      return {
        ...state,
        campaignItem: action.error ? null : action.payload
      };
    case CAMPAIGN_ITEMS_EDIT_PAGE_LOADED:
      return {
        ...state,
        campaign: action.error ? null : action.payload[0],
        assets: action.error ? [] : action.payload[1].items
      };
    case ADD_CAMPAIGN_ITEM:
      return {
        ...state,
        errors: action.error ? action.payload.error : null
      };
    case REMOVE_CAMPAIGN_ITEM:
      const campaign = state.campaign;
      campaign.items = campaign.items.filter(item => item.key != action.key);
      return {
        ...state,
        campaign: campaign
      };
    case ASSET_LIST_PAGE_UNLOADED:
    case ASSET_DETAIL_PAGE_UNLOADED:
    case ASSET_ADD_PAGE_UNLOADED:
    case ASSET_EDIT_PAGE_UNLOADED:
    case SITE_LIST_PAGE_UNLOADED:
    case SITE_DETAIL_PAGE_UNLOADED:
    case EVENT_ADD_PAGE_UNLOADED:
    case EVENT_DETAIL_PAGE_UNLOADED:
    case EVENT_LIST_PAGE_UNLOADED:
    case CAMPAIGN_LIST_PAGE_UNLOADED:
    case CAMPAIGN_DETAIL_PAGE_UNLOADED:
    case CAMPAIGN_ITEM_DETAIL_PAGE_UNLOADED:
    case CAMPAIGN_ADD_PAGE_UNLOADED:
    case CAMPAIGN_ITEMS_EDIT_PAGE_UNLOADED:
      return {};
    default:
      return state;
  }
};
